import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const PcIllustratedTwo = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, value }) => {
  return (
    <div className="illustrated-two-pc" data-model-id="16867:9962">

      <div className="contents">
        <div className="title">
          <p className="heading">Do you relate to the statement below?</p>
        </div>

        <div className="container">
          <Image src="/static/image/questionnaire/weight-loss/illustrated-two/pc/img.png" alt="Img" className="img" />

          <p className="text-wrapper">Same diets make it hard to stick with.</p>
        </div>
      </div>

      <div className="div">
          <button className={`label-wrapper ${value === "no" && "label-wrapper-select"}`} onClick={() => {clickNext("no")}}>
          <div className="label">No</div>
        </button>

          <button className={`label-wrapper ${value === "yes" && "label-wrapper-select"}`} onClick={() => {clickNext("yes")}}>
          <div className="label-2">Yes</div>
        </button>
      </div>
    </div>
  );
};
